// Press Release Registry
// Each press release includes metadata and a lazy-loaded component

export const pressReleases = [
  {
    id: '2026-03-26-pdf-hallucination', // used as the React key prop when rendering the press release list in Press.js
    slug: 'why-pdfs-make-legal-ai-hallucinate-and-how-to-fix-it', // used as the URL slug for the press release in PressRelease.js and in the URL bar
    title: 'Why PDFs Make Legal AI Hallucinate (And How To Fix It)',
    date: '2026-03-26T00:00:00-07:00', // used to sort the press releases by date in the press release list in Press.js (PDT timezone)
    summary: 'Most people assume legal AI hallucinations are a model problem. See how the emerge from the PDF and find out how you can prevent them.',
    component: () => import('./PressRelease_2026_03_26')
  },
  {
    id: '2026-02-18-launch', // used as the React key prop when rendering the press release list in Press.js
    slug: 'ex-google-meta-engineering-leader-launches-attorneyaide-attorney-aide-AI-assistant-for-personal-injury-law-medical-records-review', // used as the URL slug for the press release in PressRelease.js and in the URL bar
    title: 'Ex-Google and Meta Engineering Leader Launches AttorneyAide, an AI Assistant for Personal Injury Law Firms',
    date: '2026-02-18T00:00:00-08:00', // used to sort the press releases by date in the press release list in Press.js (PST timezone)
    summary: 'AttorneyAide today announced the public launch of its AI assistant designed specifically for personal injury law firms following months of pilot testing.',
    component: () => import('./PressRelease_2026_02_18')
  }
];

// Helper function to find press release by slug
export function getPressReleaseBySlug(slug) {
  return pressReleases.find(pr => pr.slug === slug);
}

// Helper function to get all press releases sorted by date (newest first)
export function getAllPressReleases() {
  return [...pressReleases].sort((a, b) => new Date(b.date) - new Date(a.date));
}

